const collectionCallbackMobile = function(){
  console.log( "MOBILE COLLECTION JS READY!" );
  const showDescriptionButton = document.querySelector(".show-description-button button");
  
  const collectionDescription = document.querySelector(".description-container");
  showDescriptionButton.addEventListener('click', function(event){

	collectionDescription.classList.toggle("truncated");

	if(collectionDescription.classList.contains("truncated")){
		event.target.innerHTML = "Read more";
	}
	else {
		event.target.innerHTML = "Read less"; 
	}
  });	
};

let mobileLayout = window.matchMedia('(max-width: 798px)');
      
if(mobileLayout.matches){
  if (document.readyState === "complete" || document.readyState === "interactive") {
	setTimeout(collectionCallbackMobile, 1);
  } else {
    document.addEventListener("DOMContentLoaded", collectionCallbackMobile);
  }
}